import React from "react";
import "./scss/App.scss";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./components/LoginPage";
import Dashboard from "./containers/DashboardContainer";
import Restaurant from "./containers/RestaurantContainer";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<LoginPage />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/restaurant/*" element={<Restaurant />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
